(function () {
  class GambleDisclaimer extends PIXI.Container {
    constructor() {
      super();

      this._screenDim = undefined;

      this.visible = false;
      this._screenDimTargetAlpha = 0.6;

      this._disclaimerButton = undefined;
      this._gambleSpin = undefined;

      this._gdFreeSpins = undefined;
      this._gdNextFreeSpins = undefined;
      this._gdWinChance = undefined;
      this._gdLoseChance = undefined;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._disclaimerButton = resourceManager.get("gambleDisclaimerContainer:GambleDisclaimer:gambleDisclaimerButton");
      this._disclaimerButton.mousedown = this._disclaimerButton.touchstart = this.onClickedToContinue.bind(this);

      this._gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");

      messageBus.subscribe("Gamble:OkDisclaimer", this.onClickedToContinue.bind(this));
    }

    onClickedToContinue() {
      this._disclaimerButton.interactive = false;
      soundManager.play("gambleUnderstand");

      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          // let difference = 1 - self._screenDimTargetAlpha;
          // // self._screenDim.alpha = self._screenDimTargetAlpha + (progress * difference);
          // self.alpha = 1 - progress;
        },
        function () {
          // self.alpha = 1;
          // self.visible = false;

          self._gambleSpin.start(self._gdFreeSpins, self._gdNextFreeSpins, self._gdWinChance, self._gdLoseChance, true);
          //self._callback();
        }
      );
    }

    start(freespins, nextFreeSpins, winChance, loseChance) {
      this._gdFreeSpins = freespins;
      this._gdNextFreeSpins = nextFreeSpins;
      this._gdWinChance = winChance;
      this._gdLoseChance = loseChance;

      this.visible = true;

      resourceManager.get("gambleDisclaimerContainer:GambleDisclaimer").visible = true;
      this._disclaimerButton.interactive = true;

      messageBus.post("Gamble:DisclaimerVisible");

      // let inRecovery = gameController.getIsRecovery();
      // if (inRecovery) {
      //   this.onClickedToContinue();
      // }
    }
  }

  let gambleDisclaimerCreator = function (json) {
    return new GambleDisclaimer();
  };

  let gambleDisclaimerInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleDisclaimerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "GambleDisclaimer",
    gambleDisclaimerCreator,
    gambleDisclaimerInitialiser,
    gambleDisclaimerFilesRequired
  );
})();
